import React, {useEffect} from 'react'

import './Asset.less'
import {Icon} from "@iconify/react";
import {Button, Popconfirm, Tag, Tooltip, Badge} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {assetTotalReturnAsync, setSelectedAsset, loadAssetDetail} from "../assetsSlice";

const Asset = ({
                   asset,
                   assetTypeName,
                   onEdit,
                   onDelete,
                   children,
                   showStatus = true,
                   showActions = true
               }) => {
    const {
        name,
        id,
        totalReturn = {},
        isActive,
        isTested,
        isTrading
    } = asset;

    const dispatch = useDispatch();
    const {
        selectedAsset
    } = useSelector(state => state.assets);

    useEffect(() => {
        dispatch(assetTotalReturnAsync({ assetId: id }));
    }, [dispatch, id]);

    const getStatusTags = () => {
        const tags = [];

        if (!isActive) {
            tags.push(<Tag key="inactive" color="red">Неактивный</Tag>);
        } else {
            tags.push(<Tag key="active" color="green">Активный</Tag>);
        }

        if (isTested) {
            tags.push(<Tag key="test" color="orange">Тестовый</Tag>);
        }

        if (isTrading) {
            tags.push(<Tag key="trading" color="blue">Автоторговля</Tag>);
        }

        return tags;
    };

    const getAssetBadge = () => {
        if (isTested && isTrading) {
            return <Badge.Ribbon text="Тест + Торговля" color="purple" />;
        }
        if (isTested) {
            return <Badge.Ribbon text="Тестовый" color="orange" />;
        }
        if (isTrading) {
            return <Badge.Ribbon text="Автоторговля" color="blue" />;
        }
        return null;
    };

    const formatReturn = (returnData) => {
        if (!returnData?.value) return '—';
        const value = returnData.value * 100;
        const sign = value >= 0 ? '+' : '';
        return `${sign}${value.toFixed(2)}%`;
    };

    const getHeaderClassName = () => {
        let className = 'asset-header';
        if (isTested && isTrading) className += ' test-trading';
        else if (isTested) className += ' test';
        else if (isTrading) className += ' trading';
        return className;
    };

    const getAssetClassName = () => {
        let className = 'asset';
        if (!isActive) className += ' inactive';
        if (selectedAsset?.id === id) className += ' selected';
        return className;
    };

    return (
        <div className={getAssetClassName()} onClick={() => {
            dispatch(setSelectedAsset(asset));
            dispatch(loadAssetDetail(asset));
        }}>
            <div className={getHeaderClassName()}>
                {/* Tags внутри header */}
                {showStatus && (
                    <div className='asset-tags'>
                        {getStatusTags()}
                    </div>
                )}

                <div className='asset-title-section'>
                    <h4 className='asset-name'>{name}</h4>
                </div>

                {/*
                 Badge под заголовком
                {getAssetBadge() && (
                    <div className='asset-badge-container'>
                        {getAssetBadge()}
                    </div>
                )}
*/}

                <div className='asset-type'>{assetTypeName}</div>

                {totalReturn?.value !== undefined && (
                    <div className='asset-return'>
                        <span className={`return-value ${totalReturn.value >= 0 ? 'positive' : 'negative'}`}>
                            {formatReturn(totalReturn)}
                        </span>
                    </div>
                )}
            </div>

            <div className='asset-content'>
                {children}
            </div>

            {showActions && (
                <div className='asset-footer'>
                    <ul>
                        <li>
                            <Tooltip title="Редактировать">
                                <Button
                                    type='link'
                                    onClick={() => onEdit(asset)}
                                    icon={<Icon fontSize={20} icon='material-symbols:edit-outline'/>}
                                />
                            </Tooltip>
                        </li>
                        <li>
                            <Tooltip title="Удалить">
                                <Popconfirm
                                    title='Удаление актива'
                                    description={
                                        <div>
                                            <p>Вы уверены что хотите удалить актив?</p>
                                            <strong>{name}</strong>
                                            {isTrading && <p style={{ color: '#ff4d4f', marginTop: '8px' }}>Внимание: включена автоторговля!</p>}
                                        </div>
                                    }
                                    onConfirm={() => onDelete(asset)}
                                    okText="Да"
                                    cancelText="Нет"
                                    okType="danger"
                                >
                                    <Button type='link' danger>
                                        <Icon fontSize={20} icon='material-symbols:delete-outline'/>
                                    </Button>
                                </Popconfirm>
                            </Tooltip>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Asset;
